<template>
<div>
    <el-drawer title="无货权提货" @close="closeDialog"  direction="ltr" size="49%"  :visible="wuhuoquanFlag">
       <el-form :inline="true" :model="addFrom" ref="addFrom"  :rules="rules"  class="demo-form-inline jiaoyan" label-width="120px" size="mini">
      <div>
           <div class="addressBox" >
          <h4 class="title">
            <span><i class="fa fa-cubes" aria-hidden="true"></i>基本信息</span>
          </h4>
        </div>
        <div>
          <el-form-item label="提货仓库:"   >
              <div style="min-width:260px">{{warehouseList[0].relTenantName}}</div>
          </el-form-item>
          <el-form-item label="业务单号:"  >
               <el-input  maxlength="30"   v-model="addFrom.businessNo"></el-input>
          </el-form-item>
        </div>
          <el-form-item label="提货方式:" prop="isEntrust" >
              <template >
              <el-radio-group v-model="addFrom.isEntrust"    @change="isEntrustChange" >
                <el-radio :label="1">委托</el-radio>
                <el-radio :label="2" >自提</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
           <el-form-item label="提货单位:"  prop="pickUpUnit"    >
               <el-input  :class="{disabled:addFrom.isEntrust==2}" maxlength="20" :readonly="addFrom.isEntrust==2?true:false"  v-model="addFrom.pickUpUnit"></el-input>
          </el-form-item>
          <el-form-item label="结算方式:" prop="feeMode" v-if="jsfsFlag"  >
              <el-select v-model="addFrom.feeMode" placeholder="请选择" value-key="item_no" >
                <el-option v-for="item in jsfsList" :key="item.item_no" :label="item.show_name" :value="item" ></el-option>
              </el-select>
          </el-form-item>
           <el-form-item label="结算客户:" prop="JScustomer">
            <el-select v-model="addFrom.JScustomer"  filterable remote placeholder="请输入关键词"  default-first-option
              :remote-method="xkhmcFn" value-key="custerCode" :loading="loading1">
              <el-option v-for="item in customerList" :key="item.custerCode" :label="item.custerName" :value="item"> </el-option>
            </el-select>
          </el-form-item>

        <hr>
         <div class="addressBox" >
        <h4 class="title">
          <span><i class="fa fa-truck" aria-hidden="true"></i>人车信息</span>
           <el-form-item style="margin-left:16px">
             <el-button type="primary" @click="addRCFn">新增</el-button>
          </el-form-item>
        </h4>
      </div>
         <el-table :data="addFrom.carriageInfos"  ref="table"   bordersize="mini"    style="width: 100%" height="300"   center border>
         <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <el-table-column label="提货车号" width="270">
            <template slot="header" >
              <div><span class="red">*</span>提货车号</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carriageInfos.' +scope.$index+ '.vhcNo'" :key="scope.$index" :rules="rules.vhcNo" class="table_error">
                <!-- <el-input  placeholder=""     maxlength="10"     v-model="addFrom.carriageInfos[scope.$index].vhcNo"></el-input> -->
                <el-autocomplete class="inline-input" v-model.trim="addFrom.carriageInfos[scope.$index].vhcNo"
                  :fetch-suggestions="querySearch" value-key="vhcNo" @select="handleSelect($event,scope.$index)" popper-class="xiala">
                   <template slot-scope="{ item }">
                     <div style="position: relative;">
                        <div class="name">{{ item.vhcNo }},{{ item.driverName }}</div>
                        <span class="addr">{{ item.driverIdentityNo? item.driverIdentityNo:''}}</span>
                        <span class="el-icon-close" style="position: absolute; right: 0;top: 4px;" @click.stop="delRenche(item)"></span>
                     </div>
                  </template>
                </el-autocomplete>

              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="司机姓名" width="170">
           <template slot="header" >
              <div><span class="red">*</span>司机姓名</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carriageInfos.' +scope.$index+ '.driverName'" :key="scope.$index" :rules="rules.driverName" class="table_error" >
                <el-input  placeholder=""  maxlength="10"     v-model.trim="addFrom.carriageInfos[scope.$index].driverName"></el-input>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="身份证号" min-width="170">
            <template slot="header" >
              <div>身份证号</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carriageInfos.' +scope.$index+ '.driverIdentityNo'" :key="scope.$index"  class="table_error" >
                <el-input  placeholder=""  maxlength="18"     v-model.trim="addFrom.carriageInfos[scope.$index].driverIdentityNo"></el-input>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="联系电话" width="170">
           <template slot="header" >
              <div><span class="red">*</span>联系电话</div>
            </template>
          <template slot-scope="scope">
            <div>
              <el-form-item label="" :prop="'carriageInfos.' +scope.$index+ '.driverMobile'" :key="scope.$index" :rules="rules.driverMobile" class="table_error">
                <el-input  placeholder=""   maxlength="11"     v-model.trim="addFrom.carriageInfos[scope.$index].driverMobile"></el-input>
              </el-form-item>
            </div>
          </template>
        </el-table-column>
         <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <div>
               <el-button type="text" size="mini"    @click="zhipai(scope.$index)">指派</el-button>
              <el-button type="text" size="mini"   @click="delRCFn(scope.row,scope.$index)">删除</el-button>
            </div>
          </template>
        </el-table-column>
       </el-table>

      </div>
      <el-drawer title="货物信息" size="100%" @close="closeDialog"   class="rightDrawer"
      :modal-append-to-body="false" :modal="false"  :visible="wuhuoquanFlag" >
       <div>
          <div style="padding:20px">
            <el-button type="primary" @click="qingkongFn(1)">清空</el-button>
            <el-button type="primary" @click="modelDown">模板下载</el-button>
            <el-button type="primary" @click="importFn">导入</el-button>
          </div>
          <div :style="{height:h}">
            <el-table :data="addFrom.sBillWayProductList" ref="goodTable"  bordersize="mini" class="table" center border :height="h" >
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <div>
                    <el-button type="text" size="mini"    @click="delHWFn(scope.$index)">删除</el-button>
                    <el-button type="text" size="mini"   @click="addHWFn(scope.row)">复制</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="捆包号" width="150">
                <template slot="header" >
                    <div><span class="red">*</span>捆包号</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    <el-form-item label="" :prop="'sBillWayProductList.' +scope.$index+ '.cargoBarcode'" :key="scope.$index" :rules="rules.cargoBarcode" class="table_error">
                      <el-input  placeholder=""   maxlength="20"     v-model.trim="addFrom.sBillWayProductList[scope.$index].cargoBarcode"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="品名" width="150">
               <template slot-scope="scope">
                  <div>
                    <el-form-item label="" :prop="'sBillWayProductList.' +scope.$index+ '.productName'" :key="scope.$index"  class="table_error">
                      <el-input  placeholder=""   maxlength="20"     v-model.trim="addFrom.sBillWayProductList[scope.$index].productName"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="材质" width="150">
                <template slot="header" >
                    <div><span class="red">*</span>材质</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    <el-form-item label="" :prop="'sBillWayProductList.' +scope.$index+ '.model'" :key="scope.$index" :rules="rules.model" class="table_error">
                      <el-input  placeholder=""   maxlength="20"     v-model.trim="addFrom.sBillWayProductList[scope.$index].model"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="规格" width="150">
                <template slot="header" >
                    <div><span class="red">*</span>规格</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    <el-form-item label="" :prop="'sBillWayProductList.' +scope.$index+ '.specification'" :key="scope.$index" :rules="rules.specification" class="table_error">
                      <el-input  placeholder=""   maxlength="20"     v-model.trim="addFrom.sBillWayProductList[scope.$index].specification"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="重量" width="150">
                <template slot="header" >
                    <div><span class="red">*</span>重量</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    <el-form-item label="" :prop="'sBillWayProductList.' +scope.$index+ '.weight'" :key="scope.$index" :rules="rules.weight" class="table_error">
                      <el-input  placeholder=""   maxlength="20" v-number-input.float="3"    v-model.trim="addFrom.sBillWayProductList[scope.$index].weight" @input="weightFn"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="合约号" width="150">
               <template slot-scope="scope">
                  <div>
                    <el-form-item label="" :prop="'sBillWayProductList.' +scope.$index+ '.agreementNumber'" :key="scope.$index"  class="table_error">
                      <el-input  placeholder=""   maxlength="20"     v-model.trim="addFrom.sBillWayProductList[scope.$index].agreementNumber"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="合同号" width="150">
               <template slot-scope="scope">
                  <div>
                    <el-form-item label="" :prop="'sBillWayProductList.' +scope.$index+ '.contractNumber'" :key="scope.$index"  class="table_error">
                      <el-input  placeholder=""   maxlength="20"     v-model.trim="addFrom.sBillWayProductList[scope.$index].contractNumber"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="padding:20px">
            合计:<span class="red">{{addFrom.sBillWayProductList.length}}</span>件&nbsp;&nbsp;<span class="red">{{allWeight}}</span>吨
          </div>
       </div>
       <div class="btnBox">
          <el-button  @click="wuhuoquanFlag=false">取消</el-button>
           <el-button type="primary" @click="THsaveFn()">提货</el-button>
        </div>
      </el-drawer>
    </el-form>
  </el-drawer>
  <!-- 指派 -->
  <zhipai   v-if="zhipaiFlag" @destroy="destroy" @zhipaiSave="zhipaiSave"></zhipai>
  <!-- 导入 -->
  <importC   v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
</div>
</template>

<script>
import { getDictionaryDetail, getCustomerlistByTenant, sBillCarriageInfoDel,
  feeModeType, addBill, importProducts, saveOrUpdateBill } from '@/api/soc-stock'
import { sBillCarriageInfoList, sCarriageLogDelete } from '@/api/soc-stock-cosco'
import zhipai from '@/views/soc-stock-cosco/inventoryMonitore/zhipai.vue'
import { toFixed } from '@/utils/util'
import importC from '@/components/import.vue'
export default {
  components: {
    zhipai,
    importC
  },
  name: 'lookVoucher',
  props: {
    wuhuoquanFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      h: '500px',
      warehouseList: [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }],
      addFrom: {
        isEntrust: 1,
        carriageInfos: [],
        sBillWayProductList: [{}]
      },
      rules: {
        vhcNo: [
          { required: true, message: '请输入提货车号', trigger: 'change' }
        ],
        driverName: [
          { required: true, message: '请输入提货单位/人', trigger: 'change' }
        ],
        driverIdentityNo: [
          { required: true, message: '请输入纳税人识别号/身份证号', trigger: 'change' }
        ],
        pickUpUnit: [
          { required: true, message: '请输入提货单位', trigger: 'blur' }
        ],
        isEntrust: [
          { required: true, message: '请选择自提方式', trigger: 'blur' }
        ],
        feeMode: [
          { required: true, message: '请选择结算方式', trigger: 'blur' }
        ],
        cargoBarcode: [
          { required: true, message: '请输入捆包号', trigger: 'blur' }
        ],
        model: [
          { required: true, message: '请输入材质', trigger: 'blur' }
        ],
        specification: [
          { required: true, message: '请输入规格', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ]
      },
      jsfsFlag: false,
      customerList: [],
      jsfsList: [],
      carDerList: [],
      loading1: false,
      zhipaiFlag: false,
      allWeight: 0,
      importDialog: false // 导入
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getDictionaryDetail({
      groupNo: 'settlement_flag',
      itemNo: this.warehouseList[0].relTenantCode
    }).then(res => {
      if (res.length > 0) {
        this.jsfsFlag = true
      } else {
        this.jsfsFlag = false
      }
    })
    feeModeType().then(res => {
      this.jsfsList = res
    })
    // 车牌号记忆列表
    sBillCarriageInfoList({ isDistinct: '1', billCategory: 1 }).then(res => {
      this.carDerList = res
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })
    let pH = document.documentElement.clientHeight
    this.h = (pH - 238) + 'px'
  },
  methods: {
    // 保存
    THsaveFn () {
      function isRepeat (arr) {
        var hash = {}
        for (var i in arr) {
          if (hash[arr[i].cargoBarcode]) return true; hash[arr[i].cargoBarcode] = true
        }
        return false
      }
      if (isRepeat(this.addFrom.sBillWayProductList)) {
        this.$alert('捆包号不能重复', '系统提示')
        return
      }
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          let tishiyu = ''
          if (this.addFrom.carriageInfos.length == 0) {
            tishiyu = ' 没有添加司机、车辆信息，是否继续提交？'
          } else {
            tishiyu = '是否执行提交操作？'
          }
          this.$confirm(tishiyu, '系统提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            this.jiekouFn()
          }).catch(() => {

          })
        }
      })
    },
    upperCase (str) {
      let arr = str.split('')
      let newStr = ''
      // 通过数组的forEach方法来遍历数组
      arr.forEach(function (value) {
        if (value >= 'a' && value <= 'z') { newStr += value.toUpperCase() } else { newStr += value }
      })
      return newStr
    },
    jiekouFn () {
      this.addFrom.submitStatus = 2
      let selectGoodArr = []
      this.addFrom.sBillWayProductList.forEach(item => {
        item.cargoBarcode = this.upperCase(item.cargoBarcode)
        selectGoodArr.push(item.cargoBarcode)
      })
      this.addFrom.cargoBarcodes = selectGoodArr.toString()
      if (this.addFrom.feeMode) {
        this.addFrom.feeModeType = this.addFrom.feeMode.item_no
        this.addFrom.feeModeTypeName = this.addFrom.feeMode.show_name
      }
      if (this.addFrom.JScustomer) {
        this.addFrom.payCustomerNameTaxId = this.addFrom.JScustomer.taxpayerNumber
        this.addFrom.payCustomerName = this.addFrom.JScustomer.custerName
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      this.addFrom.organizationName = this.warehouseList[0].relTenantName
      this.addFrom.organizationId = this.warehouseList[0].relTenantCode
      this.addFrom.billSource = 4
      this.addFrom.id = ''
      addBill(this.addFrom).then(res => {
        this.addFrom.id = res.id
        saveOrUpdateBill(this.addFrom).then(res => {
          loading.close()
          this.wuhuoquanFlag = false
          this.$alert('您的提单下发成功！请您尽快联系原货主【转货权】，否则影响您的货物出库！非常感谢！', '系统提示', {
            confirmButtonText: '知晓',
            callback: action => {
              this.$router.push({ name: 'StakeGoodsBillJF' })
            }
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            duration: 0,
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/soc/%E6%8F%90%E5%8D%95%E8%B4%A7%E7%89%A9%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'// 后更改页面地址
    },
    // 导入保存
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      importProducts(formData).then(res => {
        loading.close()
        this.importDialog = false
        this.addFrom.sBillWayProductList = this.addFrom.sBillWayProductList.filter(item => item.cargoBarcode)
        this.addFrom.sBillWayProductList = this.addFrom.sBillWayProductList.concat(res)
        this.weightFn()
      }).catch(error => {
        this.msg = this.$message({
          showClose: true,
          message: error.message,
          duration: 3000,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除货物
    delHWFn (index) {
      if (this.addFrom.sBillWayProductList.length == 1) {
        this.$alert('至少要保留一条货物', '系统提示')
        return
      }
      this.addFrom.sBillWayProductList.splice(index, 1)
      this.weightFn()
    },
    // 复制货物
    addHWFn (row) {
      let data = { ...row }
      this.addFrom.sBillWayProductList.push(data)
      this.weightFn()
    },
    // 清空货物
    qingkongFn () {
      this.$set(this.addFrom, 'sBillWayProductList', [{}])
      this.weightFn()
    },
    weightFn () {
      let weight = 0
      this.selectGoodArr = []
      this.addFrom.sBillWayProductList.forEach(item => {
        if (item.weight) {
          weight = (weight * 1000 + item.weight * 1000) / 1000
        }
      })
      this.allWeight = toFixed(weight, 3)
    },
    // 是否委托提货
    isEntrustChange () {
      if (this.addFrom.isEntrust == 1) {
        this.$set(this.addFrom, 'pickUpUnit', '')
      } else {
        this.$set(this.addFrom, 'pickUpUnit', localStorage.getItem('tenantName'))
      }
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    },
    // 根据查询条件获取新客户列表
    xkhmcFn (query) {
      this.loading1 = true
      getCustomerlistByTenant({
        nameLike: query,
        tenantCode: this.warehouseList[0].relTenantCode
      }).then(res => {
        this.loading1 = false
        this.customerList = res
      })
    },
    // 添加人车信息
    addRCFn () {
      this.addFrom.carriageInfos.push({})
    },
    // 删除人车
    delRCFn (row, index) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        if (row.id) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sBillCarriageInfoDel({ id: row.id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.addFrom.carriageInfos.splice(index, 1)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          this.addFrom.carriageInfos.splice(index, 1)
        }
      }).catch(() => {

      })
    },
    querySearch (str, cb) {
      let arr = []
      this.carDerList.forEach(itme => {
        if (str) {
          if (itme.vhcNo.indexOf(str) != -1) {
            arr.push(itme)
          }
        } else {
          arr.push(itme)
        }
      })
      this.callback = cb
      this.searchStr = str
      cb(arr)
    },
    handleSelect (row, index) {
      this.$set(this.addFrom.carriageInfos[index], 'driverName', row.driverName)
      this.$set(this.addFrom.carriageInfos[index], 'driverIdentityNo', row.driverIdentityNo)
      this.$set(this.addFrom.carriageInfos[index], 'driverMobile', row.driverMobile)
    },
    // 删除下拉得人车
    delRenche (item) {
      sCarriageLogDelete({ id: item.id }).then(res => {
        sBillCarriageInfoList({ isDistinct: '1', billCategory: 1 }).then(res => {
          this.carDerList = res
          this.querySearch(this.searchStr, this.callback)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 指派
    zhipai (index) {
      this.currentIndx = index
      this.zhipaiFlag = true
    },
    zhipaiSave (row) {
      this.$set(this.addFrom.carriageInfos[this.currentIndx], 'driverName', row.driverName)
      this.$set(this.addFrom.carriageInfos[this.currentIndx], 'driverIdentityNo', row.driverIdentityNo)
      this.$set(this.addFrom.carriageInfos[this.currentIndx], 'driverMobile', row.driverMobile)
      this.$set(this.addFrom.carriageInfos[this.currentIndx], 'vhcNo', row.vhcNo)
      this.zhipaiFlag = false
    },
    destroy () {
      this.zhipaiFlag = false
      this.importDialog = false
    },
    closeDialog () {
      this.$emit('update:wuhuoquanFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
/deep/.el-table .el-form-item{
  width: 100%;
}
/deep/.el-table .el-form-item__content{
   width: 100%;
}
/deep/.el-autocomplete{
 width: 100%;
}
.btnBox{
  text-align: center;
  .el-button{
        padding: 15px 25px;
        margin-top: 20px;
  }
}
/deep/.el-table .ziji {
   background: #d7ebfb !important;
}
/deep/.jiaoyan .el-form-item--mini.table_error{
  margin-bottom: 0 !important;
    margin: 14px 0!important;
}
</style>
